import { array, func } from 'prop-types'
import { kuiperClassNames, PopoverV2 } from '@opallabs/kuiper'
import { Button, Icon } from '@opallabs/lapidary'
import { AnalyticsLayer } from '@opallabs/quanta'
import MenuContent from './MenuContent'

import './styles.scss'

const SettingsMenu = ({ colorByOptions, menuTrackingCallback }) => (
  <AnalyticsLayer name="Settings Menu">
    <PopoverV2
      className={kuiperClassNames('weekview-settings')}
      content={
        <MenuContent
          colorByOptions={colorByOptions}
          menuTrackingCallback={menuTrackingCallback}
        />
      }
      hasCaret={false}
      triggerEvent="click"
      // Pin below the trigger and suppress auto-flip. Without this, a short
      // menu (Content mode's single fieldset) triggers tippy's auto-flip
      // and the menu renders above the button instead of below.
      position="bottom"
      flip={false}
      trigger={
        <Button
          ariaLabel="Open view settings"
          icon={<Icon ariaMode="hidden" glyph="gem-settings" />}
          name="view-settings"
          variant="ghost"
        />
      }
    />
  </AnalyticsLayer>
)

SettingsMenu.propTypes = {
  colorByOptions: array,
  menuTrackingCallback: func.isRequired,
}

export default SettingsMenu
